import { Check } from "components/icons/Check";
import { ReactNode } from "react";
import classNames from "classnames";
import BankWarningCircle from "static/images/BankWarningCircle.svg";
import { Accordion } from "../Accordion/Accordion";
import { Tag } from "../Tag/Tag";

type BalanceMatchingBannerProps = {
  state: "success" | "error";
  statusText: string;
  formulaText: string;
  dateRange?: string;
  children: ReactNode;
};

export const BalanceMatchingBanner = ({
  state,
  statusText,
  formulaText,
  dateRange,
  children,
}: BalanceMatchingBannerProps) => {
  const isSuccess = state === "success";
  const isError = state === "error";

  return (
    <Accordion.Root type="single" collapsible>
      <Accordion.RawItem
        value="balance-matching"
        className={classNames("t-rounded-lg t-border-0.5 t-border-solid", {
          "t-border-neutral-10": isSuccess,
          "t-border-red-20": isError,
        })}
      >
        <Accordion.Trigger className="sm:t-p-3">
          <div className="t-flex t-items-center t-gap-2 t-w-full">
            <div
              className={classNames("t-flex t-items-center t-shrink-0", {
                "t-text-dark_green-70": isSuccess,
                "t-text-red-70": isError,
              })}
            >
              {isSuccess ? (
                <Check color="currentColor" className="t-size-4" />
              ) : (
                <img
                  src={BankWarningCircle}
                  alt="BankWarningCircle"
                  className="t-size-4"
                />
              )}
            </div>
            <div className="t-flex t-items-center t-gap-1.5 t-flex-1 sm:t-flex-wrap">
              <span className="t-text-body-sm t-leading-5">
                <span
                  className={classNames({
                    "t-text-dark_green-70": isSuccess,
                    "t-text-red-70": isError,
                  })}
                >
                  {statusText}
                </span>
                <span className="t-text-text-30">: {formulaText}</span>
              </span>
              {dateRange && (
                <Tag size="small" tagType="gray" rounded icon={false}>
                  {dateRange}
                </Tag>
              )}
            </div>
          </div>
        </Accordion.Trigger>
        <Accordion.Content className="sm:t-p-3">
          <div className="t-flex t-items-center t-gap-8 t-text-body-sm sm:t-justify-between sm:t-gap-3">
            {children}
          </div>
        </Accordion.Content>
      </Accordion.RawItem>
    </Accordion.Root>
  );
};
